export class Credits{
	
	public value:number;
	

	constructor(value:number) 
	{
		this.value=value;
		

	}

	public updateValue=(value:number): void=>
	{
		
		this.value=value;

	}

	public getDisplayValue=() : string=>
	{	
		// console.log (this.value)
		return  (this.value/100).toFixed(2);//return is string
	}
	public getValue=():number=>
	{
		return (this.value/100)
	}
	public getServerVal=():number=>
	{
		return this.value;
	}



}



export function convertCreditsFromServerToClient(amount:number) : number
{
    return amount/100;
}

export function convertCreditsClientToServer(amount:number) : number
{
    return amount*100;
}


